module.exports = __webpack_public_path__ + "img/icon-external.3a5b09bf.svg";